module.exports = __webpack_public_path__ + "img/ni.5d25063c.svg";